<template>
  <div>
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">Action Template</div>
        <q-space></q-space>
        <!-- <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="saveAndAddNew"
        >
          Save & Add New
        </q-btn> -->
        <q-btn
          :loading="isLoading"
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save(true)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <div class="row q col-gutter-x-lg q-col-gutter-y-md">
          <div class="col-12">
            <q-card flat>
              <q-card-section>
                <div class="row q-mb-sm items-center">
                  <div class="col-6">
                    <div class="row items-center q-col-gutter-x-md">
                      <div class="col-3">
                        <div class="title q-my-none">Info</div>
                      </div>
                    </div>
                  </div>
                </div>
                <q-form ref="form">
                  <div class="row q-col-gutter-y-sm q-mb-lg q-col-gutter-x-lg">
                    <div class="col-12">
                      <q-input
                        :label="`Name (For internal Use, e.g. 'Get Price Quotes')`"
                        v-model="formData.name"
                        :rules="[(v) => !!v || 'Field is Required']"
                        :hint="``"
                      >
                      </q-input>
                    </div>
                    <div class="col-12">
                      <q-input
                        v-model="formData.templateValue"
                        label="Template (Will be used as the Action Text, E.g. Get price quotes for -solutionTitle-)"
                        type="textarea"
                        :rules="[(v) => !!v || 'Field is Required']"
                      >
                      </q-input>
                    </div>
                  </div>
                </q-form>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    data: () => ({
      isLoading: false,
      formData: {},
    }),
    computed: {
      ...mapGetters({
        data: "actionTemplates/current",
      }),
    },
    watch: {
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
    },
    mounted() {
      this.$store.dispatch(
        "actionTemplates/loadByID",
        this.$route.params.actionTemplates_id
      );
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        }
      },
      async save(isClose = false) {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          let payload = {
            id: this.$route.params.id,
            ...this.formData,
          };
          let result = await this.$store.dispatch(
            "actionTemplates/save",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            if (isClose) {
              this.closeDialog();
            }
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },

      closeDialog() {
        this.$router.push("/actionTemplates");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }
  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }
</style>
